// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { glsl } from "../../../lib/glsl-utils/highlight.js";
const fs = `\
vec4 warp_sampleColor(sampler2D source, vec2 texSize, vec2 coord) {
vec4 color = texture(source, coord / texSize);
vec2 clampedCoord = clamp(coord, vec2(0.0), texSize);
if (coord != clampedCoord) {
color.a *= max(0.0, 1.0 - length(coord - clampedCoord));
}
return color;
}
`;
export const warp = {
    name: 'warp',
    passes: [],
    fs
};
